import { Helmet } from "react-helmet-async";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";
import Breadcrumb from "../../../component/Breadcrumb";

export default function CabifyBanner({data, NewClass="", smallText=""}) {
  const dispatch = useDispatch();
  return (
    <>
      <Helmet>
        <link rel="preload" href={data && data.image} as="image" type="image/webp"/>
      </Helmet>
      <section className={`lyftclone-banner cabify-banner header-gap ${NewClass}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-head cabify-banner-head">
                <Breadcrumb breadcrumbData={data?.breadcrumbData}/>
                <h1 className="heading">
                  {smallText && <span>{smallText}</span>}
                  {data && data.title}</h1>
                <p>{data && data.description}</p>
                <small>21 Days Free Trial | No Credit Card Required</small>
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data && data.btn}</button>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-image">
                <img src={data && data.image} alt="Clone banner" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
